import React, { useState, useEffect, useCallback } from 'react';
import { 
  RefreshCw, Home, XCircle, CheckCircle, HelpCircle, 
  BookOpen, Settings, Info, ChevronRight, PlusCircle, ArrowLeft, ChevronLeft,
  LayoutGrid, Beaker, Zap, Atom, MousePointer2, Trash2
} from 'lucide-react';

/**
 * [GLOBAL DATA] 분자 데이터베이스 (35종)
 */
const MOLECULE_DATA = [
  { formula: 'H2', name: '수소', structure: '선형', angle: '없음', shared: 1, unshared: 0, bondPolarity: '무극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'HCl', name: '염화 수소', structure: '선형', angle: '없음', shared: 1, unshared: 3, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'BeF2', name: '플루오린화 베릴륨', structure: '선형', angle: '180°', shared: 2, unshared: 6, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'CO2', name: '이산화 탄소', structure: '선형', angle: '180°', shared: 4, unshared: 4, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'HCN', name: '사이아나화 수소', structure: '선형', angle: '180°', shared: 4, unshared: 1, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'C2F2', name: '플루오린화 에타인', structure: '선형', angle: '180°', shared: 5, unshared: 6, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'BCl3', name: '염화 붕소', structure: '평면 삼각형', angle: '120°', shared: 3, unshared: 9, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'BF3', name: '플루오린화 붕소', structure: '평면 삼각형', angle: '120°', shared: 3, unshared: 9, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'CH2O', name: '폼알데하이드', structure: '평면 삼각형', angle: '약 120°', shared: 4, unshared: 2, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'CH4', name: '메테인', structure: '정사면체', angle: '109.5°', shared: 4, unshared: 0, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'CF4', name: '사플루오린화 탄소', structure: '정사면체', angle: '109.5°', shared: 4, unshared: 12, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'CH3Cl', name: '클로로메테인', structure: '사면체', angle: '약 109.5°', shared: 4, unshared: 3, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'NH3', name: '암모니아', structure: '삼각뿔', angle: '107°', shared: 3, unshared: 1, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'NF3', name: '삼플루오린화 질소', structure: '삼각뿔', angle: '102°', shared: 3, unshared: 10, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'H2O', name: '물', structure: '굽은형', angle: '104.5°', shared: 2, unshared: 2, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'H2S', name: '황화 수소', structure: '굽은형', angle: '92°', shared: 2, unshared: 2, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'OF2', name: '이플루오린화 산소', structure: '굽은형', angle: '103°', shared: 2, unshared: 8, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'PF5', name: '오플루오린화 인', structure: '삼각 쌍뿔', angle: '90°, 120°', shared: 5, unshared: 15, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'SF6', name: '육플루오린화 황', structure: '정팔면체', angle: '90°', shared: 6, unshared: 18, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'PCl3', name: '삼염화 인', structure: '삼각뿔', angle: '약 100°', shared: 3, unshared: 10, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'SiH4', name: '시레인', structure: '정사면체', angle: '109.5°', shared: 4, unshared: 0, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'CS2', name: '이황화 탄소', structure: '선형', angle: '180°', shared: 4, unshared: 4, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'N2', name: '질소', structure: '선형', angle: '없음', shared: 3, unshared: 2, bondPolarity: '무극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'O2', name: '산소', structure: '선형', angle: '없음', shared: 2, unshared: 4, bondPolarity: '무극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'F2', name: '플루오린', structure: '선형', angle: '없음', shared: 1, unshared: 6, bondPolarity: '무극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'Cl2', name: '염소', structure: '선형', angle: '없음', shared: 1, unshared: 6, bondPolarity: '무극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'HF', name: '플루오린화 수소', structure: '선형', angle: '없음', shared: 1, unshared: 3, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'NOF', name: '니트로실 플루오라이드', structure: '굽은형', angle: '약 110°', shared: 3, unshared: 6, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'COF2', name: '카보닐 플루오라이드', structure: '평면 삼각형', angle: '약 120°', shared: 4, unshared: 8, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'N2F2', name: '이플루오린화 이질소', structure: '굽은형(평면)', angle: '약 114°', shared: 4, unshared: 8, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'C2F4', name: '사플루오린화 에틸렌', structure: '평면 구조', angle: '120°', shared: 6, unshared: 12, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
  { formula: 'FCN', name: '플루오린화 사이안', structure: '선형', angle: '180°', shared: 4, unshared: 4, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'HNO', name: '니트로실 수소', structure: '굽은형', angle: '약 108°', shared: 3, unshared: 3, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'O2F2', name: '이플루오린화 이산화물', structure: '굽은형(사슬)', angle: '약 109°', shared: 3, unshared: 10, bondPolarity: '극성 공유 결합', molecularPolarity: '극성 분자' },
  { formula: 'C2F6', name: '육플루오린화 에테인', structure: '사면체 결합', angle: '109.5°', shared: 7, unshared: 18, bondPolarity: '극성 공유 결합', molecularPolarity: '무극성 분자' },
];

/**
 * [GLOBAL DATA] 주기성 데이터베이스 (전기 음성도 정밀 수정 반영)
 */
const PERIODIC_DATA = [
  { n: 1, sym: 'H', name: '수소', p: 1, g: 1, ve: 1, en: 2.2 },
  { n: 2, sym: 'He', name: '헬륨', p: 1, g: 18, ve: 0, en: null },
  { n: 3, sym: 'Li', name: '리튬', p: 2, g: 1, ve: 1, en: 1.0 },
  { n: 4, sym: 'Be', name: '베릴륨', p: 2, g: 2, ve: 2, en: 1.6 },
  { n: 5, sym: 'B', name: '붕소', p: 2, g: 13, ve: 3, en: 2.0 },
  { n: 6, sym: 'C', name: '탄소', p: 2, g: 14, ve: 4, en: 2.6 },
  { n: 7, sym: 'N', name: '질소', p: 2, g: 15, ve: 5, en: 3.0 },
  { n: 8, sym: 'O', name: '산소', p: 2, g: 16, ve: 6, en: 3.4 },
  { n: 9, sym: 'F', name: '플루오린', p: 2, g: 17, ve: 7, en: 4.0 },
  { n: 10, sym: 'Ne', name: '네온', p: 2, g: 18, ve: 0, en: null },
  { n: 11, sym: 'Na', name: '나트륨', p: 3, g: 1, ve: 1, en: 0.9 },
  { n: 12, sym: 'Mg', name: '마그네슘', p: 3, g: 2, ve: 2, en: 1.3 },
  { n: 13, sym: 'Al', name: '알루미늄', p: 3, g: 13, ve: 3, en: 1.6 },
  { n: 14, sym: 'Si', name: '규소', p: 3, g: 14, ve: 4, en: 1.9 },
  { n: 15, sym: 'P', name: '인', p: 3, g: 15, ve: 2.2 },
  { n: 16, sym: 'S', name: '황', p: 3, g: 16, ve: 6, en: 2.6 },
  { n: 17, sym: 'Cl', name: '염소', p: 3, g: 17, ve: 7, en: 3.2 },
  { n: 18, sym: 'Ar', name: '아르곤', p: 3, g: 18, ve: 0, en: null },
  { n: 19, sym: 'K', name: '칼륨', p: 4, g: 1, ve: 1, en: 0.8 },
  { n: 20, sym: 'Ca', name: '칼슘', p: 4, g: 2, ve: 2, en: 1.0 },
  { n: 35, sym: 'Br', name: '브로민', p: 4, g: 17, ve: 7, en: 3.0 },
  { n: 53, sym: 'I', name: '아이오딘', p: 5, g: 17, ve: 7, en: 2.7 },
];

const MOLECULAR_EXCLUSIONS = {
  structure: ['N2F2', 'C2F4', 'O2F2', 'C2F6'],
  angle: ['H2', 'HCl', 'NF3', 'H2S', 'OF2', 'PF5', 'SF6', 'PCl3', 'N2', 'O2', 'F2', 'Cl2', 'HF', 'NOF', 'N2F2', 'HNO', 'O2F2', 'C2F6'],
  bondPolarity: ['C2F2', 'N2F2', 'C2F4', 'O2F2', 'C2F6'],
  molecularPolarity: ['N2F2', 'C2F6']
};

// --- HELPER COMPONENTS ---

/**
 * [HELPER] 화학식 아래첨자 렌더러
 */
const Formula = ({ text, className, forceLarge = false }) => {
  if (text === undefined || text === null) return null;
  const strText = String(text);
  if (forceLarge) return <span className={className}>{strText}</span>;
  
  const parts = strText.split(/(\d+)/);
  return (
    <span className={className}>
      {parts.map((part, i) => 
        /^\d+$/.test(part) ? <sub key={i} className="bottom-[-0.1em] text-[0.7em] font-black">{part}</sub> : part
      )}
    </span>
  );
};

const FractionDisplay = ({ num, den, className = "" }) => (
  <div className={`inline-flex flex-col items-center justify-center align-middle ${className}`}>
    <span className="border-b border-current px-2 leading-none pb-1 font-bold">{num}</span>
    <span className="leading-none pt-1 font-bold">{den}</span>
  </div>
);

/**
 * [HELPER] 공통 선택지 렌더러
 */
const ChoiceContent = ({ value }) => {
  if (typeof value === 'string' && value.includes('/')) {
    const [num, den] = value.split('/');
    return <FractionDisplay num={num} den={den} />;
  }
  if (typeof value === 'string' && /[A-Z]/.test(value) && value.length < 10) {
    return <Formula text={value} />;
  }
  return <span>{value}</span>;
};

const RegularChoiceContent = ({ value }) => {
  if (typeof value === 'string' && value.includes('/')) {
    const [num, den] = value.split('/');
    return <FractionDisplay num={num} den={den} />;
  }
  if (typeof value === 'string' && /[A-Z]/.test(value) && value.length < 10) {
    return <Formula text={value} />;
  }
  return <span className="font-black text-[22px]">{value}</span>;
};

/**
 * [WRAPPER] 레이아웃 박스 래퍼
 */
const LayoutWrapper = ({ children, header, footer }) => (
  <div className="flex flex-col h-full w-full bg-slate-50 p-2 text-slate-800 font-medium overflow-hidden justify-center items-center">
    <div className="flex flex-col w-full max-w-md bg-white rounded-[2rem] shadow-2xl overflow-hidden border border-slate-100 h-full max-h-[95dvh] md:max-h-[850px] transition-all relative">
      {header && header}
      <div className="flex-1 flex flex-col overflow-y-auto custom-scrollbar relative px-5 py-3">
        {children}
      </div>
      {footer && footer}
    </div>
  </div>
);

// --- MODULES ---

/**
 * [MODULE 1] 분자 구조 Master
 */
const MolecularMasterModule = ({ onBackToAgent, incorrectNotes, setIncorrectNotes }) => {
  const [view, setView] = useState('setup');
  const [selectedCategories, setSelectedCategories] = useState(['structure', 'angle', 'shared', 'unshared', 'bondPolarity', 'molecularPolarity', 'ratioUS']);
  const [questionCount, setQuestionCount] = useState(10);
  const [customCountInput, setCustomCountInput] = useState(false);
  const [autoIncorrect, setAutoIncorrect] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [choices, setChoices] = useState([]);
  const [answered, setAnswered] = useState(false);
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [results, setResults] = useState([]);
  const [showFeedback, setShowFeedback] = useState(false);
  const [isAddedToIncorrect, setIsAddedToIncorrect] = useState(false);

  const getRatioValue = useCallback((molecule, type) => {
    const s = molecule.shared;
    const u = molecule.unshared;
    const gcd = (a, b) => b ? gcd(b, a % b) : a;
    if (s === 0 || u === 0) return "정의되지 않음";
    const common = gcd(u, s);
    return common === s ? `${u / s}` : `${u / common}/${s / common}`;
  }, []);

  const generateChoices = useCallback((correctValue, category, currentMolecule, subType) => {
    if (category === 'bondPolarity' || category === 'molecularPolarity') {
      return category === 'bondPolarity' ? ['극성 공유 결합', '무극성 공유 결합'] : ['극성 분자', '무극성 분자'];
    }
    
    let allPossibleValues = [];
    if (subType === 'find') {
      const targetRatio = getRatioValue(currentMolecule, category);
      allPossibleValues = MOLECULE_DATA
        .filter(m => m.shared !== 0 && m.unshared !== 0 && getRatioValue(m, category) !== targetRatio)
        .map(m => m.formula);
    } else if (category === 'ratioUS') {
      allPossibleValues = [...new Set(MOLECULE_DATA.filter(m => m.shared !== 0 && m.unshared !== 0).map(m => getRatioValue(m, category)))].filter(v => v !== "정의되지 않음");
    } else {
      allPossibleValues = [...new Set(MOLECULE_DATA.map(m => m[category]))];
    }

    let pool = [...allPossibleValues.filter(v => v !== correctValue && !['사면체 결합', '굽은형(평면)', '굽은형(사슬)'].includes(v))].sort(() => Math.random() - 0.5);
    let distractors = pool.slice(0, 3);
    return [...distractors, correctValue].sort(() => Math.random() - 0.5);
  }, [getRatioValue]);

  const prepareQuestion = useCallback((q) => {
    if (!q) return;
    setAnswered(false); setSelectedChoice(null); setShowFeedback(false); setIsAddedToIncorrect(false); 
    let correctValue;
    if (q.category === 'ratioUS') {
      q.subType = Math.random() > 0.5 ? 'prop' : 'find';
      if (q.subType === 'prop') {
        correctValue = getRatioValue(q.molecule, q.category);
        setChoices(generateChoices(correctValue, q.category, q.molecule, 'prop'));
      } else {
        correctValue = q.molecule.formula;
        setChoices(generateChoices(correctValue, q.category, q.molecule, 'find'));
      }
    } else {
      correctValue = q.molecule[q.category];
      setChoices(generateChoices(correctValue, q.category, q.molecule, 'prop'));
    }
  }, [generateChoices, getRatioValue]);

  const startLearning = () => {
    const pool = [...MOLECULE_DATA];
    const generatedQuestions = [];
    while (generatedQuestions.length < questionCount) {
      const catId = selectedCategories[Math.floor(Math.random() * selectedCategories.length)];
      const filteredPool = pool.filter(m => {
        if (MOLECULAR_EXCLUSIONS[catId] && MOLECULAR_EXCLUSIONS[catId].includes(m.formula)) return false;
        if (catId === 'ratioUS' && (m.shared === 0 || m.unshared === 0)) return false;
        return true;
      });
      if (filteredPool.length > 0) {
        const mol = filteredPool[Math.floor(Math.random() * filteredPool.length)];
        generatedQuestions.push({ molecule: mol, category: catId });
      }
    }
    setQuestions(generatedQuestions); setCurrentIndex(0); prepareQuestion(generatedQuestions[0]); setResults([]); setView('play');
  };

  const addToIncorrect = useCallback((q) => {
    if (!q) return;
    setIncorrectNotes(prev => {
      if (prev.some(item => item.molecule.formula === q.molecule.formula && item.category === q.category)) return prev;
      return [...prev, q];
    });
    setIsAddedToIncorrect(true); 
  }, [setIncorrectNotes]);

  const handleChoiceSelect = (choice) => {
    if (answered) return;
    const currentQ = questions[currentIndex];
    let isCorrect = currentQ.subType === 'find' ? choice === currentQ.molecule.formula : (currentQ.category === 'ratioUS' ? choice === getRatioValue(currentQ.molecule, currentQ.category) : choice === currentQ.molecule[currentQ.category]);
    setSelectedChoice(choice); setAnswered(true);
    
    setResults(prev => {
      const updated = [...prev];
      updated[currentIndex] = { ...currentQ, correct: isCorrect, userChoice: choice };
      return updated;
    });

    if (!isCorrect && autoIncorrect) addToIncorrect(currentQ);
    setTimeout(() => setShowFeedback(true), 600);
  };

  const handleNext = () => {
    if (currentIndex < questions.length - 1) {
      const nextIdx = currentIndex + 1;
      setCurrentIndex(nextIdx); prepareQuestion(questions[nextIdx]);
    } else setView('summary');
  };

  const endSessionEarly = () => {
    const finalResults = [...results];
    for (let i = 0; i < questions.length; i++) {
      if (!finalResults[i]) {
        finalResults[i] = { ...questions[i], correct: false, userChoice: null };
        if (autoIncorrect) addToIncorrect(questions[i]);
      }
    }
    setResults(finalResults);
    setView('summary');
  };

  const clearIncorrectNotes = () => setIncorrectNotes([]);

  const CATEGORIES_LIST = [
    { id: 'structure', label: '분자 구조' },
    { id: 'angle', label: '결합각' },
    { id: 'shared', label: '공유 전자쌍 수' },
    { id: 'unshared', label: '비공유 전자쌍 수' },
    { id: 'bondPolarity', label: '공유 결합 극성' },
    { id: 'molecularPolarity', label: '분자 극성' },
    { id: 'ratioUS', label: '비공유/공유 비율' },
  ];

  if (view === 'setup') {
    return (
      <LayoutWrapper header={<div className="bg-indigo-600 py-6 px-8 text-white text-center shrink-0 relative"><button onClick={onBackToAgent} className="absolute left-6 top-8 text-indigo-200 hover:text-white"><ArrowLeft size={24} /></button><Zap className="w-10 h-10 mb-2 mx-auto" /><h1 className="text-2xl font-black tracking-tight mb-1">분자 구조 Master</h1><p className="text-[10px] text-indigo-100 opacity-80 uppercase tracking-widest italic font-bold">Made by ASH SCIENCE</p></div>} footer={<div className="p-4 bg-slate-50/30 flex gap-2 shrink-0 border-t"><button onClick={() => setView('review')} className="flex-1 py-4 bg-white border border-indigo-200 text-indigo-600 rounded-xl font-bold text-[12px]"><BookOpen size={18} className="inline mr-1" /> 오답 ({incorrectNotes.length})</button><button onClick={startLearning} className="flex-[1.5] py-4 bg-indigo-600 text-white rounded-xl font-black text-[15px]">학습 시작 <ChevronRight size={20} className="inline ml-1" /></button></div>}>
        <div className="space-y-6">
          <section className="space-y-4">
            <h3 className="text-[12px] font-black text-slate-400 uppercase tracking-widest pl-1">문제 유형 선택</h3>
            <div className="grid grid-cols-1 gap-2">
              {CATEGORIES_LIST.map(cat => (
                <button
                  key={cat.id}
                  onClick={() => {
                    if (selectedCategories.includes(cat.id)) {
                      if (selectedCategories.length > 1) setSelectedCategories(selectedCategories.filter(c => c !== cat.id));
                    } else setSelectedCategories([...selectedCategories, cat.id]);
                  }}
                  className={`py-5 px-6 rounded-2xl border-2 text-[16px] leading-tight text-left transition-all active:scale-[0.98] ${
                    selectedCategories.includes(cat.id) ? 'border-indigo-600 bg-indigo-50 text-indigo-700 font-black shadow-sm' : 'border-slate-100 text-slate-400 bg-white font-bold'
                  }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </section>

          <section className="space-y-4">
            <h3 className="text-[12px] font-black text-slate-400 uppercase tracking-widest pl-1">문항 수</h3>
            <div className="grid grid-cols-3 gap-2">
              {[10, 15, 20, 25, 30].map(n => (
                <button
                  key={n}
                  onClick={() => { setQuestionCount(n); setCustomCountInput(false); }}
                  className={`py-4 rounded-xl border-2 font-black text-[16px] transition-all active:scale-95 ${
                    !customCountInput && questionCount === n ? 'bg-indigo-600 border-indigo-600 text-white shadow-md' : 'bg-white border-slate-100 text-slate-500 hover:border-indigo-200'
                  }`}
                >
                  {n}
                </button>
              ))}
              <button onClick={() => setCustomCountInput(true)} className={`py-4 rounded-xl border-2 font-black text-[16px] transition-all active:scale-95 ${customCountInput ? 'bg-indigo-600 border-indigo-600 text-white shadow-md' : 'bg-white border-slate-100 text-slate-500 hover:border-indigo-200'}`}>직접</button>
            </div>
            {customCountInput && (
              <div className="mt-2 animate-in slide-in-from-top-2">
                <input type="number" value={questionCount} onChange={(e) => setQuestionCount(Math.max(1, parseInt(e.target.value) || 0))} className="w-full p-5 bg-white border-2 border-indigo-600 rounded-2xl focus:outline-none font-black text-center text-xl shadow-lg" placeholder="문항 수를 입력하세요" autoFocus />
              </div>
            )}
          </section>
        </div>
      </LayoutWrapper>
    );
  }

  if (view === 'play') {
    const q = questions[currentIndex];
    const cat = CATEGORIES_LIST.find(c => c.id === q.category);
    const isUserCorrect = results[currentIndex]?.correct;
    const isRatioFindType = q.category === 'ratioUS' && q.subType === 'find';

    return (
      <LayoutWrapper header={<div className="flex justify-between items-center px-6 py-5 border-b shrink-0 bg-white"><button onClick={() => setView('setup')} className="p-2.5 bg-slate-50 rounded-xl text-slate-400"><Home size={20} /></button><div className="flex flex-col items-center"><span className="text-[10px] text-slate-400 font-black uppercase tracking-widest">Progress</span><div className="text-[15px] font-black text-indigo-600">{currentIndex + 1} / {questions.length}</div></div><button onClick={endSessionEarly} className="p-2.5 bg-slate-50 rounded-xl text-red-300"><XCircle size={20} /></button></div>}>
        {showFeedback ? (
          <div className="flex flex-col h-full animate-in fade-in duration-500 overflow-hidden pt-0">
            <div className="flex-1 flex flex-col justify-start h-full">
              <div className="flex flex-col justify-center items-center py-1">
                <div className={`inline-flex p-1 rounded-full mb-1 ${isUserCorrect ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                  {isUserCorrect ? <CheckCircle size={24} /> : <XCircle size={24} />}
                </div>
                <div className="w-full bg-slate-50 rounded-[2rem] p-3.5 mb-2 text-center border shadow-inner shrink-0">
                  <Formula text={q.molecule.formula} className="text-4xl font-black text-slate-800" />
                  <p className="text-xs text-slate-400 font-bold mb-1.5">({q.molecule.name})</p>
                  <div className="flex flex-col gap-0.5 text-left px-4">
                    <div className="flex justify-between items-center py-1 border-b border-slate-200/50"><span className="text-[10px] text-slate-400 font-black uppercase tracking-tighter">질문</span><span className="text-sm font-black text-indigo-600">{cat?.label}</span></div>
                    <div className="flex justify-between items-center py-1"><span className="text-[10px] text-slate-400 font-black uppercase tracking-tighter">정답</span><span className="text-sm font-black text-green-600">{q.subType === 'find' ? q.molecule.formula : (q.category === 'ratioUS' ? <ChoiceContent value={getRatioValue(q.molecule, q.category)} /> : q.molecule[q.category])}</span></div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-1.5 w-full mb-3 shrink-0">
                  {[
                    { label: '구조', val: q.molecule.structure },
                    { label: '결합각', val: q.molecule.angle },
                    { label: '공유전자쌍', val: q.molecule.shared },
                    { label: '비공유전자쌍', val: q.molecule.unshared }
                  ].map((item, idx) => (
                    <div key={idx} className="p-3.5 bg-white rounded-2xl border-2 border-slate-50 shadow-sm flex flex-col justify-center min-h-[75px]">
                      <p className="text-[10px] font-black text-indigo-300 uppercase mb-1 leading-none">{item.label}</p>
                      <div className="text-slate-800 font-black text-[16px] leading-tight break-keep">{item.val}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="space-y-2 mt-2 pb-4 shrink-0 px-1">
                <button onClick={() => addToIncorrect(q)} className={`w-full py-9 border-4 rounded-xl font-black text-[17px] flex items-center justify-center gap-2 transition-all shadow-md ${isAddedToIncorrect ? 'bg-red-500 text-white border-red-500' : 'bg-white border-slate-200 text-slate-600'}`}>
                  <PlusCircle size={24} /> {isAddedToIncorrect ? '오답 저장됨' : '내 오답노트에 추가하기'}
                </button>
                <button onClick={handleNext} className="w-full py-9 border-4 border-transparent bg-indigo-600 text-white rounded-xl font-black text-[17px] shadow-xl flex items-center justify-center gap-2 active:bg-indigo-700">
                  다음 문항으로 <ChevronRight size={24} className="inline" />
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col h-full overflow-hidden">
            <div className="flex flex-col justify-center items-center pt-2 pb-2 shrink-0 min-h-[170px]">
              {isRatioFindType ? (
                <div className="text-center animate-in zoom-in-95">
                  <p className="text-[28px] font-black text-indigo-600 mb-1 leading-tight tracking-tighter">비공유/공유 비율이</p>
                  <div className="transform scale-[2.2] py-8 my-4">
                    <ChoiceContent value={getRatioValue(q.molecule, q.category)} />
                  </div>
                  <p className="text-[28px] font-black text-indigo-600 mt-1 leading-tight tracking-tighter">인 분자는?</p>
                </div>
              ) : (
                <>
                  <div className="mb-4">
                    <Formula text={q.molecule.formula} className="text-7xl font-black text-slate-800 tracking-tighter drop-shadow-sm leading-none" />
                  </div>
                  <div className="w-full p-5 bg-slate-50 rounded-[2rem] border-2 border-dashed text-center shrink-0">
                    <p className="text-[11px] text-slate-400 font-bold mb-1 uppercase italic opacity-70 underline decoration-slate-300 tracking-widest">Question</p>
                    <p className="text-2xl font-black text-slate-700 leading-tight">이 분자의 {cat?.label}</p>
                  </div>
                </>
              )}
            </div>

            {/* 4지선다 박스 사이 간격 확대 (gap-3) */}
            <div className="w-full flex-1 flex flex-col items-center justify-start pt-2 pb-8 overflow-hidden">
              <div className="grid grid-cols-2 gap-3 w-full max-w-[340px]">
                {choices.map((choice, idx) => (
                  <button key={idx} onClick={() => handleChoiceSelect(choice)} 
                    className="w-full h-[110px] rounded-[2rem] font-black border-2 transition-all flex justify-center items-center active:scale-[0.97] border-slate-100 bg-white text-slate-600 shadow-lg">
                    <div className="text-center w-full px-1">
                      <RegularChoiceContent value={choice} />
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </LayoutWrapper>
    );
  };

  const renderSummary = () => {
    const score = results.filter(r => r?.correct).length;
    const total = results.length;
    return (
      <LayoutWrapper>
        <div className="bg-indigo-600 py-12 px-8 text-white text-center shrink-0">
          <h2 className="text-sm font-bold mb-1 opacity-80 uppercase tracking-widest italic">Session Complete</h2>
          <div className="text-8xl font-black mb-3">{total === 0 ? 0 : Math.round((score/total)*100)}<span className="text-2xl ml-1">%</span></div>
          <p className="text-base font-bold opacity-90">{total}문제 중 {score}개를 맞혔습니다!</p>
        </div>
        <div className="p-6 flex-1 flex flex-col overflow-hidden h-full">
          <div className="flex-1 space-y-3 overflow-y-auto custom-scrollbar mb-6 pr-2">
            {results.map((r, i) => (
              <div key={i} className={`flex items-center justify-between p-5 rounded-3xl border-2 ${r.correct ? 'bg-green-50/50 border-green-100' : 'bg-red-50/50 border-red-100'}`}>
                <div className="flex flex-col">
                  <Formula text={r.molecule.formula} className="font-black text-slate-800 text-[18px]" />
                  <span className="text-[10px] text-slate-400 font-black uppercase tracking-widest">{CATEGORIES_LIST.find(c => c.id === r.category)?.label}</span>
                </div>
                <div className="flex flex-col items-end">
                  <span className={`text-[11px] font-black px-3 py-1 rounded-full mb-1 ${r.correct ? 'bg-green-200 text-green-700' : 'bg-red-200 text-red-700'}`}>{r.correct ? 'PASS' : 'FAIL'}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-2 gap-3 shrink-0 mt-auto pb-6">
            <button onClick={() => setView('setup')} className="py-5 bg-indigo-600 text-white rounded-3xl font-black shadow-lg">다시하기</button>
            <button onClick={() => setView('review')} className="py-5 bg-white border-2 border-indigo-100 text-indigo-600 rounded-3xl font-black">오답 복습</button>
          </div>
        </div>
      </LayoutWrapper>
    );
  };

  const renderReview = () => (
    <LayoutWrapper header={<div className="max-w-md mx-auto w-full flex justify-between items-center p-6 border-b shrink-0 bg-white"><h2 className="text-2xl font-black text-slate-800 flex items-center gap-2.5 tracking-tighter"><BookOpen className="text-indigo-600" size={28} /> 분자 오답 노트</h2><button onClick={() => setView('setup')} className="p-2.5 bg-slate-50 rounded-xl text-slate-400"><Home size={24} /></button></div>} footer={<div className="p-6 pt-0 shrink-0 border-t bg-white flex flex-col gap-2">{incorrectNotes.length > 0 && (<><button onClick={clearIncorrectNotes} className="w-full py-3 bg-red-50 text-red-600 rounded-xl font-bold flex items-center justify-center gap-2 border border-red-100 active:bg-red-100 transition-all text-sm"><Trash2 size={16} /> 오답 노트 비우기</button><button onClick={() => { const reviewQs = [...incorrectNotes].sort(() => Math.random() - 0.5); setQuestions(reviewQs); setCurrentIndex(0); prepareQuestion(reviewQs[0]); setResults([]); setView('play'); }} className="w-full py-5 bg-indigo-600 text-white rounded-[1.5rem] font-black shadow-xl text-lg"><RefreshCw size={24} className="inline mr-1" /> 오답 집중 복습 시작</button></>)}</div>}>
      <div className="flex-1 overflow-y-auto custom-scrollbar space-y-4 py-2">
        {incorrectNotes.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-center py-20"><CheckCircle className="w-20 h-20 text-green-100 mx-auto mb-6" /><p className="text-slate-400 font-black text-[18px]">기록된 오답이 없습니다!</p></div>
        ) : (
          incorrectNotes.map((q, i) => (
            <div key={i} className="bg-white rounded-3xl p-6 shadow-sm border-l-[6px] border-l-red-400 flex flex-col relative shrink-0">
              <div className="flex justify-between items-start mb-5"><div><Formula text={q.molecule.formula} className="text-[32px] font-black text-slate-800" /><p className="text-[13px] font-bold text-slate-400">{q.molecule.name}</p></div><button onClick={() => setIncorrectNotes(prev => prev.filter((_, idx) => idx !== i))} className="p-1 text-slate-200"><XCircle size={28} /></button></div>
              <div className="grid grid-cols-2 gap-3 mb-5"><div className="p-4 bg-slate-50 rounded-2xl border flex flex-col justify-center"><p className="text-[9px] font-black text-slate-400 uppercase">질문 개념</p><p className="text-slate-700 font-bold text-[14px]">{CATEGORIES_LIST.find(c => c.id === q.category)?.label}</p></div><div className="p-4 bg-indigo-50 rounded-2xl border flex flex-col justify-center"><p className="text-[9px] font-black text-indigo-300 uppercase">Correct</p><div className="text-indigo-700 font-black text-[14px] leading-tight break-keep">{q.category === 'ratioUS' ? (() => { const r = getRatioValue(q.molecule, q.category); return r.includes('/') ? <FractionDisplay num={r.split('/')[0]} den={r.split('/')[1]} /> : r; })() : q.molecule[q.category]}</div></div></div>
            </div>
          ))
        )}
      </div>
    </LayoutWrapper>
  );

  return (
    <div className="h-full w-full">
      {view === 'setup' && renderHome()}
      {view === 'play' && renderPlay()}
      {view === 'summary' && renderSummary()}
      {view === 'review' && renderReview()}
    </div>
  );
};

/**
 * [MODULE 2] 화학-주기성 Master
 */
const PeriodicMasterModule = ({ onBackToAgent, incorrectNotes, setIncorrectNotes }) => {
  const [view, setView] = useState('setup');
  const [selectedTypes, setSelectedTypes] = useState(['atomicNumber', 'periodGroup', 'valenceElectrons', 'electronegativity']);
  const [questionCount, setQuestionCount] = useState(10);
  const [customCountInput, setCustomCountInput] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showAnswer, setShowAnswer] = useState(false);
  const [answered, setAnswered] = useState(false);
  const [selectedElement, setSelectedElement] = useState(null);
  const [results, setResults] = useState([]);
  const [isAddedToIncorrect, setIsAddedToIncorrect] = useState(false);

  const PERIODIC_TYPES = [
    { id: 'atomicNumber', label: '원자 번호' },
    { id: 'periodGroup', label: '주기 / 족' },
    { id: 'valenceElectrons', label: '원자가 전자 수' },
    { id: 'electronegativity', label: '전기 음성도 비교' },
  ];

  const resetAll = useCallback(() => {
    setView('setup'); setResults([]); setCurrentIndex(0); setShowAnswer(false); setIsAddedToIncorrect(false);
  }, []);

  const startLearning = () => {
    const generated = [];
    while (generated.length < questionCount) {
      const type = selectedTypes[Math.floor(Math.random() * selectedTypes.length)];
      if (type === 'atomicNumber') {
        const pool = PERIODIC_DATA.filter(e => e.n <= 20);
        const el = pool[Math.floor(Math.random() * pool.length)];
        const subType = Math.random() > 0.5 ? 'symToNum' : 'numToSym';
        generated.push({ type, el, subType });
      } else if (type === 'periodGroup') {
        const target = PERIODIC_DATA[Math.floor(Math.random() * PERIODIC_DATA.length)];
        const subType = Math.random() > 0.5 ? 'symToPG' : 'pgToSym';
        generated.push({ type, el: target, subType });
      } else if (type === 'valenceElectrons') {
        const el = PERIODIC_DATA[Math.floor(Math.random() * PERIODIC_DATA.length)];
        generated.push({ type, el });
      } else if (type === 'electronegativity') {
        const poolWithEn = PERIODIC_DATA.filter(e => e.en !== null);
        const A = poolWithEn[Math.floor(Math.random() * poolWithEn.length)];
        const candidates = poolWithEn.filter(B => B !== A && (B.p === A.p || B.g === A.g));
        if (candidates.length > 0) {
          const B = candidates[Math.floor(Math.random() * candidates.length)];
          generated.push({ type, elements: [A, B].sort(() => Math.random() - 0.5) });
        }
      }
    }
    setQuestions(generated); setCurrentIndex(0); setShowAnswer(false); setAnswered(false); setIsAddedToIncorrect(false); setResults([]); setView('play');
  };

  const handleAddIncorrect = useCallback((q) => {
    setIncorrectNotes(prev => {
      if (prev.some(item => JSON.stringify(item) === JSON.stringify(q))) return prev;
      return [...prev, q];
    });
    setIsAddedToIncorrect(true);
  }, [setIncorrectNotes]);

  const handleNext = () => {
    const currentQ = questions[currentIndex];
    const isFlash = currentQ.type !== 'electronegativity';
    const isWinner = !isFlash && (selectedElement?.en === Math.max(...currentQ.elements.map(e => e.en)));
    const isCorrect = isFlash || isWinner;

    setResults(prev => {
      const updated = [...prev];
      updated[currentIndex] = { ...currentQ, correct: isCorrect };
      return updated;
    });

    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1); setShowAnswer(false); setAnswered(false); setSelectedElement(null); setIsAddedToIncorrect(false);
    } else setView('summary');
  };

  const endSessionEarly = () => {
    const finalResults = [...results];
    for (let i = 0; i < questions.length; i++) {
      if (!finalResults[i]) {
        const q = questions[i];
        finalResults[i] = { ...q, correct: false };
        if (q.type === 'electronegativity') handleAddIncorrect(q);
      }
    }
    setResults(finalResults);
    setView('summary');
  };

  if (view === 'setup') {
    return (
      <LayoutWrapper header={<div className="bg-amber-500 py-6 px-8 text-white text-center shrink-0 relative"><button onClick={onBackToAgent} className="absolute left-6 top-8 text-amber-100 hover:text-white"><ArrowLeft size={24} /></button><Atom className="w-10 h-10 mb-2 mx-auto" /><h1 className="text-2xl font-black tracking-tight mb-1">화학-주기성 Master</h1><p className="text-[10px] text-amber-100 opacity-80 uppercase tracking-widest italic font-bold">Made by ASH SCIENCE</p></div>} footer={<div className="p-4 bg-slate-50/30 flex gap-2 shrink-0 border-t"><button onClick={() => setView('review')} className="flex-1 py-4 bg-white border border-amber-200 text-amber-600 rounded-xl font-bold text-[12px]"><BookOpen size={18} className="inline mr-1" /> 오답 ({incorrectNotes.length})</button><button onClick={startLearning} className="flex-[1.5] py-4 bg-amber-500 text-white rounded-xl font-black text-[15px]">학습 시작 <ChevronRight size={20} className="inline ml-1" /></button></div>}>
        <div className="space-y-6">
          <section className="space-y-4">
            <h3 className="text-[12px] font-black text-slate-400 uppercase tracking-widest pl-1">학습 카테고리</h3>
            <div className="grid grid-cols-1 gap-2">
              {PERIODIC_TYPES.map(t => (
                <button 
                  key={t.id} 
                  onClick={() => setSelectedTypes(prev => prev.includes(t.id) ? (prev.length > 1 ? prev.filter(x => x !== t.id) : prev) : [...prev, t.id])} 
                  className={`py-5 px-6 rounded-2xl border-2 text-[16px] text-left transition-all active:scale-[0.98] ${selectedTypes.includes(t.id) ? 'border-amber-500 bg-amber-50 text-amber-700 font-black shadow-sm' : 'border-slate-100 text-slate-400 bg-white font-bold'}`}
                >
                  {t.label}
                </button>
              ))}
            </div>
          </section>

          <section className="space-y-4">
            <h3 className="text-[12px] font-black text-slate-400 uppercase tracking-widest pl-1">문항 수</h3>
            <div className="grid grid-cols-3 gap-2">
              {[10, 15, 20, 25, 30].map(n => (
                <button 
                  key={n} 
                  onClick={() => { setQuestionCount(n); setCustomCountInput(false); }} 
                  className={`py-4 rounded-xl border-2 font-black text-[16px] transition-all active:scale-95 ${!customCountInput && questionCount === n ? 'bg-amber-500 border-amber-500 text-white shadow-md' : 'bg-white border-slate-100 text-slate-500 hover:border-amber-200'}`}
                >
                  {n}
                </button>
              ))}
              <button onClick={() => setCustomCountInput(true)} className={`py-4 rounded-xl border-2 font-black text-[16px] transition-all active:scale-95 ${customCountInput ? 'bg-amber-500 border-amber-500 text-white shadow-md' : 'bg-white border-slate-100 text-slate-500 hover:border-amber-200'}`}>직접</button>
            </div>
            {customCountInput && (
              <div className="mt-2 animate-in slide-in-from-top-2">
                <input type="number" value={questionCount} onChange={(e) => setQuestionCount(Math.max(1, parseInt(e.target.value) || 0))} className="w-full p-5 bg-white border-2 border-amber-500 rounded-2xl focus:outline-none font-black text-center text-xl shadow-lg" placeholder="문항 수를 입력하세요" autoFocus />
              </div>
            )}
          </section>
        </div>
      </LayoutWrapper>
    );
  }

  if (view === 'play') {
    const q = questions[currentIndex];
    const isFlashcard = q.type !== 'electronegativity';
    
    const questionHeader = q.type === 'atomicNumber' ? '원자 번호는?' 
                        : q.type === 'periodGroup' ? '주기 / 족은?' 
                        : q.type === 'valenceElectrons' ? '원자가 전자 수는?'
                        : '전기 음성도 비교';

    const content = isFlashcard ? (
      q.type === 'atomicNumber' ? (
        q.subType === 'symToNum' ? { q: q.el.sym, a: `${q.el.n}번` } : { q: `${q.el.n}번`, a: q.el.sym }
      ) : q.type === 'periodGroup' ? (
        q.subType === 'symToPG' ? { q: q.el.sym, a: `${q.el.p}주기 ${q.el.g}족` } : { q: `${q.el.p}주기 ${q.el.g}족`, a: `${q.el.sym} (${q.el.name})` }
      ) : { q: q.el.sym, a: `${q.el.ve}개` }
    ) : null;

    return (
      <LayoutWrapper header={<div className="flex justify-between items-center px-6 py-5 border-b shrink-0 bg-white"><button onClick={() => setView('setup')} className="p-2.5 bg-slate-50 rounded-xl text-slate-400"><Home size={20} /></button><div className="flex flex-col items-center"><span className="text-[10px] text-slate-400 font-black uppercase tracking-widest">Progress</span><div className="text-[15px] font-black text-amber-600">{currentIndex + 1} / {questions.length}</div></div><button onClick={endSessionEarly} className="p-2.5 bg-slate-50 rounded-xl text-red-300"><XCircle size={20} /></button></div>}>
        <div className="flex flex-col h-full">
          {isFlashcard ? (
            <div className="flex-1 flex flex-col pt-4">
              <div className="text-center py-6">
                <h2 className="text-[32px] font-black text-amber-600 tracking-tight">{questionHeader}</h2>
              </div>
              {!showAnswer ? (
                <button onClick={() => setShowAnswer(true)} className="flex-1 flex flex-col items-center justify-center p-8 bg-slate-50 rounded-[2.5rem] border-4 border-dashed border-amber-200 animate-in zoom-in-95">
                  <span className="text-[100px] font-black text-slate-800 leading-none tracking-tighter">
                    <Formula text={content.q} forceLarge={true} />
                  </span>
                  <div className="mt-12 text-amber-500 animate-bounce flex flex-col items-center">
                    <MousePointer2 size={32} />
                    <span className="text-[11px] font-black mt-2 uppercase tracking-widest">Touch to Reveal Answer</span>
                  </div>
                </button>
              ) : (
                <div className="flex-1 flex flex-col items-center animate-in fade-in duration-500">
                  <div className="flex-1 flex flex-col items-center justify-center w-full">
                    <span className="text-2xl font-bold text-slate-300 mb-6">
                      <Formula text={content.q} forceLarge={true} />
                    </span>
                    <span className="text-[64px] font-black text-amber-600 text-center leading-tight break-keep px-4">
                      <Formula text={content.a} forceLarge={true} />
                    </span>
                  </div>
                  <div className="w-full space-y-3 pb-6 shrink-0">
                    <button onClick={() => handleAddIncorrect(q)} className={`w-full py-5 border-4 rounded-2xl font-black text-[16px] flex items-center justify-center gap-2 transition-all ${isAddedToIncorrect ? 'bg-red-500 text-white border-red-500' : 'bg-white border-slate-200 text-slate-600'}`}>
                      <PlusCircle size={22} /> {isAddedToIncorrect ? '오답 저장됨' : '내 오답노트에 추가하기'}
                    </button>
                    <button onClick={handleNext} className="w-full py-5 bg-amber-500 text-white rounded-[1.5rem] font-black text-lg">다음 문항으로 <ChevronRight size={22} className="inline" /></button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="flex-1 flex flex-col pt-4">
              <div className="text-center py-6 shrink-0">
                <h2 className="text-[28px] font-black text-amber-600 tracking-tight">전기 음성도가 더 큰 원소?</h2>
                <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mt-1">Electronegativity Compare</p>
              </div>
              <div className="grid grid-cols-2 gap-4 my-auto shrink-0">
                {q.elements.map((el, i) => {
                  const isWinner = el.en === Math.max(...q.elements.map(e => e.en));
                  const isSelected = selectedElement === el;
                  // 소수점 첫째자리 고정 로직 반영
                  const enDisplay = el.en !== null ? el.en.toFixed(1) : '-';
                  return (
                    <button key={i} onClick={() => { if (!answered) { setSelectedElement(el); setAnswered(true); if (!isWinner) handleAddIncorrect(q); } }} disabled={answered} className={`h-40 rounded-[2rem] border-4 transition-all flex flex-col items-center justify-center ${!answered ? 'bg-white border-slate-100 shadow-lg active:scale-95' : isWinner ? 'bg-green-50 border-green-500 text-green-700' : isSelected ? 'bg-red-50 border-red-500 text-red-700' : 'bg-slate-50 border-slate-200 opacity-40'}`}>
                      <span className="text-5xl font-black mb-1">{el.sym}</span>
                      <span className="text-xs font-bold opacity-60">{el.name}</span>
                      {answered && <span className="mt-2 font-mono font-black text-lg">{enDisplay}</span>}
                    </button>
                  );
                })}
              </div>
              {answered && (
                <div className="mt-auto space-y-3 pb-6 shrink-0">
                  <button onClick={() => handleAddIncorrect(q)} className={`w-full py-4 border-4 rounded-2xl font-black text-[14px] flex items-center justify-center gap-2 transition-all ${isAddedToIncorrect ? 'bg-red-500 text-white border-red-500' : 'bg-white border-slate-200 text-slate-600'}`}>
                    <PlusCircle size={18} /> {isAddedToIncorrect ? '오답 저장됨' : '이 문항 오답노트에 추가'}
                  </button>
                  <button onClick={handleNext} className="w-full py-5 bg-amber-500 text-white rounded-[1.5rem] font-black text-lg shadow-lg">다음 문항으로 <ChevronRight size={22} className="inline" /></button>
                </div>
              )}
            </div>
          )}
        </div>
      </LayoutWrapper>
    );
  }

  if (view === 'summary') {
    const score = results.filter(r => r?.correct).length;
    const total = results.length;
    return (
      <LayoutWrapper>
        <div className="bg-amber-500 py-12 px-8 text-white text-center shrink-0">
          <h2 className="text-sm font-bold mb-1 opacity-80 uppercase tracking-widest italic">Periodic Result</h2>
          <div className="text-8xl font-black mb-3 text-white">{total === 0 ? 0 : Math.round((score/total)*100)}<span className="text-2xl ml-1">%</span></div>
          <p className="text-base font-bold opacity-90">{total}문제 중 {score}개를 맞혔습니다!</p>
        </div>
        <div className="p-6 flex-1 flex flex-col overflow-hidden h-full">
          <div className="flex-1 space-y-3 overflow-y-auto custom-scrollbar mb-6 pr-2">
            {results.map((r, i) => (
              <div key={i} className={`flex items-center justify-between p-5 rounded-3xl border-2 ${r.correct ? 'bg-green-50/50 border-green-100' : 'bg-red-50/50 border-red-100'}`}>
                <div className="flex flex-col">
                  <span className="font-black text-slate-800 text-[18px]">{r.type === 'electronegativity' ? `${r.elements[0].sym}/${r.elements[1].sym}` : (r.el?.sym || r.el?.n)}</span>
                  <span className="text-[10px] text-slate-400 font-black uppercase">{PERIODIC_TYPES.find(t => t.id === r.type)?.label}</span>
                </div>
                <div className="flex flex-col items-end">
                  <span className={`text-[11px] font-black px-3 py-1 rounded-full mb-1 ${r.correct ? 'bg-green-200 text-green-700' : 'bg-red-200 text-red-700'}`}>{r.correct ? 'PASS' : 'FAIL'}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-2 gap-3 shrink-0 mt-auto pb-6">
            <button onClick={() => setView('setup')} className="py-5 bg-amber-500 text-white rounded-3xl font-black shadow-lg">다시하기</button>
            <button onClick={() => setView('review')} className="py-5 bg-white border-2 border-amber-100 text-amber-600 rounded-3xl font-black">오답 복습</button>
          </div>
        </div>
      </LayoutWrapper>
    );
  }

  if (view === 'review') {
    return (
      <LayoutWrapper header={<div className="max-w-md mx-auto w-full flex justify-between items-center p-6 border-b shrink-0 bg-white"><h2 className="text-2xl font-black text-slate-800 flex items-center gap-2.5 tracking-tighter"><BookOpen className="text-amber-500" size={28} /> 주기성 오답 노트</h2><button onClick={() => setView('setup')} className="p-2.5 bg-slate-50 rounded-xl text-slate-400"><Home size={24} /></button></div>} footer={incorrectNotes.length > 0 && (<div className="p-6 pt-0 shrink-0 border-t bg-white flex flex-col gap-2"><button onClick={() => setIncorrectNotes([])} className="w-full py-3 bg-red-50 text-red-600 rounded-xl font-bold flex items-center justify-center gap-2 border border-red-100 active:bg-red-100 transition-all text-sm"><Trash2 size={16} /> 오답 노트 비우기</button><button onClick={() => { const reviewQs = [...incorrectNotes].sort(() => Math.random() - 0.5); setQuestions(reviewQs); setCurrentIndex(0); setShowAnswer(false); setAnswered(false); setView('play'); }} className="w-full py-5 bg-amber-500 text-white rounded-[1.5rem] font-black shadow-xl text-lg mt-4"><RefreshCw size={24} className="inline mr-1" /> 오답 집중 복습 시작</button></div>)}>
        <div className="flex-1 overflow-y-auto custom-scrollbar space-y-4 py-2">{incorrectNotes.length === 0 ? (<div className="flex flex-col items-center justify-center h-full text-center py-20"><CheckCircle className="w-20 h-20 text-amber-100 mx-auto mb-6" /><p className="text-slate-400 font-black text-[18px]">기록된 오답이 없습니다!</p></div>) : (incorrectNotes.map((q, i) => (
          <div key={i} className="bg-white rounded-3xl p-6 shadow-sm border-l-[6px] border-l-amber-400 flex flex-col relative shrink-0">
            <div className="flex justify-between items-start mb-5"><div><span className="text-[32px] font-black text-slate-800">{q.el?.sym || (q.elements && q.elements[0].sym + "/" + q.elements[1].sym)}</span><p className="text-[13px] font-bold text-slate-400">{q.type === 'electronegativity' ? '전기 음성도 비교' : '개념 학습'}</p></div><button onClick={() => setIncorrectNotes(prev => prev.filter((_, idx) => idx !== i))} className="p-1 text-slate-200"><XCircle size={28} /></button></div>
            <div className="p-4 bg-slate-50 rounded-2xl border flex flex-col justify-center"><p className="text-[9px] font-black text-slate-400 uppercase">학습 데이터</p><p className="text-slate-700 font-bold text-[14px] leading-tight break-keep">{q.type === 'atomicNumber' ? `원자 번호: ${q.el.n}번` : q.type === 'periodGroup' ? `${q.el.p}주기 ${q.el.g}족` : q.type === 'valenceElectrons' ? `원자가 전자: ${q.el.ve}개` : `EN 비교: ${q.elements[0].sym}(${q.elements[0].en.toFixed(1)}) vs ${q.elements[1].sym}(${q.elements[1].en.toFixed(1)})`}</p></div>
          </div>
        )))}</div>
      </LayoutWrapper>
    );
  }
};

/**
 * [MAIN ENTRY] 화학 Master Agent
 */
const App = () => {
  const [activeModule, setActiveModule] = useState('agent');
  
  // 오답노트 전역 상태 관리 (기록 유지용)
  const [molecularIncorrectNotes, setMolecularIncorrectNotes] = useState([]);
  const [periodicIncorrectNotes, setPeriodicIncorrectNotes] = useState([]);

  const renderAgent = () => (
    <div className="flex flex-col h-full w-full bg-slate-50 p-4 text-slate-900 font-medium overflow-y-auto items-center justify-center">
      <div className="w-full max-w-md space-y-8 py-10">
        <header className="text-center space-y-3">
          <div className="inline-flex p-4 bg-white rounded-3xl shadow-xl border border-indigo-50 mb-2"><Atom className="w-16 h-16 text-indigo-600 animate-spin-slow" /></div>
          <h1 className="text-4xl font-black tracking-tighter text-slate-800 leading-tight">화학 Master Agent</h1>
          <p className="text-sm text-indigo-500 font-bold tracking-widest italic uppercase">made by ASH SCIENCE</p>
        </header>
        <div className="grid grid-cols-1 gap-4">
          <button onClick={() => setActiveModule('molecular')} className="group relative bg-white p-6 rounded-[2.5rem] shadow-lg border border-slate-100 text-left transition-all active:scale-[0.98] overflow-hidden"><div className="absolute right-[-10px] top-[-10px] opacity-[0.03]"><Zap size={150} className="text-indigo-900" /></div><div className="relative z-10 flex items-start gap-5"><div className="p-4 bg-indigo-50 rounded-3xl text-indigo-600"><Beaker size={32} /></div><div className="space-y-1"><h3 className="text-xl font-black text-slate-800">화학-분자 구조 Master</h3><p className="text-sm text-slate-400 font-semibold leading-snug">VSEPR 이론, 전자쌍 비율,<br/>결합각 및 극성 판정 완벽 정복</p></div></div></button>
          <button onClick={() => setActiveModule('periodic')} className="group relative bg-white p-6 rounded-[2.5rem] shadow-lg border border-slate-100 text-left transition-all active:scale-[0.98] overflow-hidden"><div className="absolute right-[-10px] top-[-10px] opacity-[0.03]"><Atom size={150} className="text-amber-900" /></div><div className="relative z-10 flex items-start gap-5"><div className="p-4 bg-amber-50 rounded-3xl text-amber-600"><Atom size={32} /></div><div className="space-y-1"><h3 className="text-xl font-black text-slate-800">화학-주기성 Master</h3><p className="text-sm text-slate-400 font-semibold leading-snug">원자 번호, 주기/족, 전자 수,<br/>전기 음성도 비교 훈련</p></div></div></button>
        </div>
        <footer className="text-center space-y-4 pt-10"><div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 rounded-full text-slate-400 text-xs font-black"><Info size={14} /> <span>PLATFORM VER 3.0</span></div><p className="text-[11px] text-slate-300 font-bold">Copyright © 2026 ASH SCIENCE. All Rights Reserved.</p></footer>
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 font-sans antialiased text-slate-900 touch-manipulation bg-slate-50 overflow-hidden">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Pretendard:wght@400;500;700;900&display=swap');
        :root { --app-height: 100dvh; }
        body { font-family: 'Pretendard', sans-serif; background-color: #f8fafc; overflow: hidden; height: var(--app-height); width: 100vw; position: fixed; }
        .custom-scrollbar::-webkit-scrollbar { width: 4px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
        .animate-spin-slow { animation: spin 8s linear infinite; }
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      `}</style>
      <main className="h-full w-full overflow-hidden">
        {activeModule === 'agent' && renderAgent()}
        {activeModule === 'molecular' && (
          <MolecularMasterModule 
            onBackToAgent={() => setActiveModule('agent')} 
            incorrectNotes={molecularIncorrectNotes} 
            setIncorrectNotes={setMolecularIncorrectNotes} 
          />
        )}
        {activeModule === 'periodic' && (
          <PeriodicMasterModule 
            onBackToAgent={() => setActiveModule('agent')} 
            incorrectNotes={periodicIncorrectNotes} 
            setIncorrectNotes={setPeriodicIncorrectNotes} 
          />
        )}
      </main>
    </div>
  );
};

export default App;
